import { FirearmStorageLocationItemComponentBase } from './firearm-storage-location-item.component.base';
import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, postCodeValidator, requiredValidator, UserStorage } from '@scisys-uim/uim-common';
import { FirearmStorageLocation } from 'assets-model';
import { BusinessUnitService, FirearmStorageLocationService, RefCodeStorage } from 'assets-service';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-firearm-storage-location-item',
  templateUrl: './firearm-storage-location-item.component.html',
  styleUrls: ['./firearm-storage-location-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class FirearmStorageLocationItemComponent extends FirearmStorageLocationItemComponentBase {

  constructor(protected firearmStorageLocationService: FirearmStorageLocationService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(firearmStorageLocationService, businessUnitService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.locationTypeLoadSelectionList();
  }
  
  createNewItem(): FirearmStorageLocation {
    return new FirearmStorageLocation({
      disposalLocation: false
    });
  }
    
  itemSet() {
    super.itemSet();
  }
  
  createForm(): FormGroup {
    const form = super.createForm();
    form.controls.postcode.setValidators([requiredValidator, postCodeValidator()]);
    return form;
  }

  setDefaultDisabledFields(): void {
    super.setDefaultDisabledFields();
    this.firearmStorageLocationId.disable();
    this.createdBy.disable();
    this.createdDate.disable();
    this.updatedBy.disable();
    this.updatedDate.disable();
  }
  
}





